const encodeMapQuery = (query) => encodeURIComponent(query)

export const contactChannels = {
  mainPhoneDisplay: '0905-479-0966',
  mainPhoneHref: 'tel:+639054790966',
  viber: [
    {
      label: 'Mayon Main / General Inquiries',
      number: '639054790966',
      href: 'viber://chat?number=%2B639054790966'
    },
    {
      label: 'M Place Branch',
      number: '639154850578',
      href: 'viber://chat?number=%2B639154850578'
    }
  ],
  whatsapp: [
    {
      label: 'M Place Branch',
      number: '639154850578',
      href: 'https://wa.me/639154850578'
    }
  ]
}

export const branches = [
  {
    id: 'main',
    name: 'Mayon Main Branch',
    label: 'Main Branch',
    address: '#857 Lot 3 Mayon St., Brgy. Amoranto, Quezon City',
    email: 'mayonlab18@gmail.com',
    phone: '0905-479-0966',
    phoneHref: 'tel:+639054790966',
    hours: 'Mon–Sat & holidays: 6:00 AM–5:00 PM',
    sundayHours: 'Sunday: 6:00 AM–12:00 NN',
    image: require('@/assets/landingpage/contactus/map2.jpg'),
    imageAlt: 'Map graphic for Mayon Main Branch on Mayon Street near Welcome Rotonda, Sun Mall, Jollibee, A. Boni Market, St. Peter, Mercury Drug, and Motolite',
    postalAddress: {
      '@type': 'PostalAddress',
      streetAddress: '#857 Lot 3 Mayon St., Brgy. Amoranto',
      addressLocality: 'Quezon City',
      addressCountry: 'PH'
    },
    openingHoursSpecification: [
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], opens: '06:00', closes: '17:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Sunday', opens: '06:00', closes: '12:00' }
    ],
    mapUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeMapQuery('#857 Lot 3 Mayon St. Brgy. Amoranto Quezon City')}`,
    services: ['Laboratory tests', 'Medical packages', 'Drug testing', 'Consultation']
  },
  {
    id: 'm-place',
    name: 'Mayon M Place Branch',
    label: 'M Place South Triangle',
    address: '#116 Ground Floor, SMDC M Place, Panay Ave., Quezon City',
    email: 'mayonlabmplace@gmail.com',
    phone: '0915-485-0578',
    phoneHref: 'tel:+639154850578',
    hours: 'Mon–Sun & holidays: 6:00 AM–5:00 PM',
    sundayHours: 'Daily branch schedule',
    image: require('@/assets/landingpage/contactus/map1.jpg'),
    imageAlt: 'Map graphic for Mayon M Place Panay Branch at SMDC M Place near Panay Avenue, Quezon Avenue, Mother Ignacia Avenue, Camelot Hotel, ABS-CBN, and PhilHealth',
    postalAddress: {
      '@type': 'PostalAddress',
      streetAddress: '#116 Ground Floor, SMDC M Place, Panay Ave.',
      addressLocality: 'Quezon City',
      addressCountry: 'PH'
    },
    openingHoursSpecification: [
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'], opens: '06:00', closes: '17:00' }
    ],
    mapUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeMapQuery('Mayon Clinical Laboratory M Place South Triangle Quezon City')}`,
    services: ['Laboratory tests', 'Packages', 'Imaging inquiries', 'HMO support']
  }
]

export const navigation = [
  { label: 'Home', route: 'home', hash: 'hero' },
  { label: 'Packages', route: 'home', hash: 'packages' },
  { label: 'Services', route: 'home', hash: 'services' },
  { label: 'HMO', route: 'home', hash: 'hmo' },
  { label: 'Branches', path: '/branches' },
  { label: 'About', route: 'about', hash: 'about' }
]

export const portalLink = {
  label: 'Online Portal',
  url: 'https://mayonmplaceportal.com'
}

export const heroTrustItems = [
  'DOH-accredited laboratory',
  'ISO 9001:2015 certified',
  'EQAS quality assurance',
  'Quezon City branches'
]

export const valueProofs = [
  { value: '2004', label: 'Serving patients since' },
  { value: 'DOH', label: 'Accredited laboratory' },
  { value: 'ISO', label: '9001:2015 certified' }
]


export const aboutHighlights = [
  { value: '2004', label: 'Serving patients since' },
  { value: 'DOH', label: 'Accredited laboratory' },
  { value: '2', label: 'Quezon City branches' },
  { value: 'ISO', label: '9001:2015 quality system' }
]

export const quickActions = [
  {
    title: 'View Packages',
    text: 'Check routine, pre-employment, wellness, and executive packages.',
    icon: 'pi pi-clipboard',
    hash: 'packages'
  },
  {
    title: 'Search Services',
    text: 'Find laboratory, imaging, drug testing, vaccine, and consultation services.',
    icon: 'pi pi-search',
    hash: 'services'
  },
  {
    title: 'Find a Branch',
    text: 'Open directions to Mayon Main or M Place branch.',
    icon: 'pi pi-map-marker',
    hash: 'branches'
  },
  {
    title: 'HMO Partners',
    text: 'Review selected HMO partners and quality affiliations.',
    icon: 'pi pi-shield',
    hash: 'hmo'
  }
]

export const packages = [
  {
    'name': 'Package 1',
    'badge': 'Routine wellness',
    'price': '₱600',
    'regularPrice': '₱950',
    'savings': '₱350',
    'description': 'Core blood sugar, kidney, liver, lipid, blood count, and urine screening package.',
    'includes': [
      'FBS',
      'BUN',
      'Creatinine',
      'Uric Acid',
      'SGOT',
      'SGPT',
      'Lipid Profile',
      'CBC',
      'Routine Urinalysis'
    ],
    'bestFor': 'Routine wellness and baseline screening'
  },
  {
    'name': 'Package 2',
    'badge': 'Expanded wellness',
    'price': '₱1,000',
    'regularPrice': '₱1,560',
    'savings': '₱560',
    'description': 'Expanded wellness screening with HbA1c and electrolyte testing added to Package 1.',
    'includes': [
      'FBS',
      'BUN',
      'Creatinine',
      'Uric Acid',
      'SGOT',
      'SGPT',
      'Lipid Profile',
      'CBC',
      'Routine Urinalysis',
      'HbA1c',
      'Sodium',
      'Potassium',
      'Chloride'
    ],
    'bestFor': 'Broader metabolic and electrolyte screening'
  },
  {
    'name': 'Package 3 - Male',
    'badge': 'Male health',
    'price': '₱1,800',
    'regularPrice': '₱2,660',
    'savings': '₱860',
    'description': 'Expanded laboratory screening with PSA and CEA cancer-marker tests for male patients.',
    'includes': [
      'FBS',
      'BUN',
      'Creatinine',
      'Uric Acid',
      'SGOT',
      'SGPT',
      'Lipid Profile',
      'CBC',
      'Routine Urinalysis',
      'HbA1c',
      'Sodium',
      'Potassium',
      'Chloride',
      'PSA',
      'CEA'
    ],
    'bestFor': 'Comprehensive male wellness screening'
  },
  {
    'name': 'Package 3 - Female',
    'badge': 'Female health',
    'price': '₱2,000',
    'regularPrice': '₱2,860',
    'savings': '₱860',
    'description': 'Expanded laboratory screening with CA 125 and CEA cancer-marker tests for female patients.',
    'includes': [
      'FBS',
      'BUN',
      'Creatinine',
      'Uric Acid',
      'SGOT',
      'SGPT',
      'Lipid Profile',
      'CBC',
      'Routine Urinalysis',
      'HbA1c',
      'Sodium',
      'Potassium',
      'Chloride',
      'CA 125',
      'CEA'
    ],
    'bestFor': 'Comprehensive female wellness screening'
  },
  {
    'name': 'Package 4 - Male',
    'badge': 'Male + ultrasound',
    'price': '₱2,400',
    'regularPrice': '₱3,260',
    'savings': '₱860',
    'description': 'Package 3 male screening plus a whole-abdomen ultrasound.',
    'includes': [
      'FBS',
      'BUN',
      'Creatinine',
      'Uric Acid',
      'SGOT',
      'SGPT',
      'Lipid Profile',
      'CBC',
      'Routine Urinalysis',
      'HbA1c',
      'Sodium',
      'Potassium',
      'Chloride',
      'PSA',
      'CEA',
      'Whole Abdomen Ultrasound'
    ],
    'bestFor': 'Male executive screening with imaging'
  },
  {
    'name': 'Package 4 - Female',
    'badge': 'Female + ultrasound',
    'price': '₱2,500',
    'regularPrice': '₱3,460',
    'savings': '₱960',
    'description': 'Package 3 female screening plus a whole-abdomen ultrasound.',
    'includes': [
      'FBS',
      'BUN',
      'Creatinine',
      'Uric Acid',
      'SGOT',
      'SGPT',
      'Lipid Profile',
      'CBC',
      'Routine Urinalysis',
      'HbA1c',
      'Sodium',
      'Potassium',
      'Chloride',
      'CA 125',
      'CEA',
      'Whole Abdomen Ultrasound'
    ],
    'bestFor': 'Female executive screening with imaging'
  }
]

export const serviceCategories = [
  {
    name: 'Fully Automated Laboratory Services',
    icon: 'pi pi-heart',
    text: 'CBC, urinalysis, fecalysis, blood typing, coagulation, kidney, liver, lipid, sugar, and routine laboratory testing services.',
    filterCategories: ['Hematology', 'Chemistry', 'Urinalysis', 'Fecalysis']
  },
  {
    name: 'Special Laboratory',
    icon: 'pi pi-sparkles',
    text: 'Specialized testing support including thyroid hormones, hepatitis and serology, cancer markers, cardiac markers, and related assays.',
    filterCategories: ['Thyroid / Hormone', 'Hepatitis / Serology', 'Cancer Markers', 'Special Laboratory'],
    filterTerms: ['troponin']
  },
  {
    name: 'X-ray',
    icon: 'pi pi-image',
    text: 'Routine X-ray support with branch confirmation for schedule, availability, and requested view.',
    filterCategories: ['X-ray'],
    filterTerms: ['x-ray', 'xray']
  },
  {
    name: 'ECG',
    icon: 'pi pi-chart-line',
    text: 'Electrocardiogram service for employment, routine checkups, and doctor-requested diagnostics.',
    filterCategories: ['ECG'],
    filterTerms: ['ecg']
  },
  {
    name: 'Ultrasound',
    icon: 'pi pi-search',
    text: 'Ultrasound inquiries with branch confirmation for schedule, preparation, and final rate.',
    filterCategories: ['Ultrasound'],
    filterTerms: ['ultrasound']
  },
  {
    name: '2D Echo w/ Doppler',
    icon: 'pi pi-wave-pulse',
    text: '2D echocardiography with Doppler support, subject to branch schedule and confirmation.',
    filterCategories: ['2D Echo w/ Doppler'],
    filterTerms: ['2d echo', 'doppler']
  },
  {
    name: 'Drug Test',
    icon: 'pi pi-shield',
    text: 'DOH-accredited drug testing support for employment, compliance, and onsite requests.',
    filterCategories: ['Drug Test'],
    filterTerms: ['drug', 'methamphetamine', 'thc']
  },
  {
    name: 'Home Service',
    icon: 'pi pi-home',
    text: 'Home service inquiries for selected diagnostic needs, subject to location, schedule, and branch confirmation.',
    filterCategories: ['Home Service'],
    filterTerms: ['home service']
  },
  {
    name: 'Mobile Onsite',
    icon: 'pi pi-building',
    text: 'Mobile onsite services for companies, APE, onsite medical support, and onsite drug testing inquiries.',
    filterCategories: ['Mobile Onsite'],
    filterTerms: ['mobile', 'onsite', 'ape']
  },
  {
    name: 'Vaccination',
    icon: 'pi pi-plus-circle',
    text: 'Vaccination availability, schedule, and rate should be confirmed directly with the branch.',
    filterCategories: ['Vaccination'],
    filterTerms: ['vaccine', 'vaccination']
  }
]

export const services = [
  {
    'name': '2 Hours Post Prandial Flavored',
    'category': 'Chemistry',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Cbc W/ Platelet',
    'category': 'Hematology',
    'price': '₱150',
    'notes': ''
  },
  {
    'name': 'Vdrl/Vdrl',
    'category': 'Hepatitis / Serology',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': '2 Hours Post Prandial(Meal)',
    'category': 'Chemistry',
    'price': '₱80',
    'notes': ''
  },
  {
    'name': 'Clotting Time',
    'category': 'Hematology',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': 'TPHA',
    'category': 'Hepatitis / Serology',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Albumin',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Bleeding Time',
    'category': 'Hematology',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': 'Hiv 1/2',
    'category': 'Hepatitis / Serology',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'Liver Function Test',
    'category': 'Chemistry',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Reticulocyte Count',
    'category': 'Hematology',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'RUBELLA IgG/IgM each',
    'category': 'Hepatitis / Serology',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Alkaline Phosphatase',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'ESR',
    'category': 'Hematology',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Widal Test',
    'category': 'Hepatitis / Serology',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'Amylase',
    'category': 'Chemistry',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Malarial Rapid Test',
    'category': 'Hematology',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'THYPHIDOT IgG/IgM',
    'category': 'Hepatitis / Serology',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Bilirubin (Tot/Direct/Indirect)',
    'category': 'Chemistry',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'PBS (Peripheral Smear)',
    'category': 'Hematology',
    'price': '₱150',
    'notes': ''
  },
  {
    'name': 'Troponin Test',
    'category': 'Hepatitis / Serology',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Blood Urea Nitrogen (BUN)',
    'category': 'Chemistry',
    'price': '₱60',
    'notes': ''
  },
  {
    'name': 'Rh Typing',
    'category': 'Hematology',
    'price': '₱50',
    'notes': ''
  },
  {
    'name': 'Dengue Combo with CBC',
    'category': 'Hepatitis / Serology',
    'price': '₱800',
    'notes': 'NS1, IgG/IgM with CBC'
  },
  {
    'name': 'Chloride',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Abo Typing',
    'category': 'Hematology',
    'price': '₱50',
    'notes': ''
  },
  {
    'name': 'LEPTO SPIRA IgG/IgM',
    'category': 'Hepatitis / Serology',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'CKMB',
    'category': 'Chemistry',
    'price': '₱360',
    'notes': ''
  },
  {
    'name': 'Protrombin Time',
    'category': 'Hematology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Anti-Streptolysin - O (Aso)',
    'category': 'Hepatitis / Serology',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'CPK',
    'category': 'Chemistry',
    'price': '₱360',
    'notes': ''
  },
  {
    'name': 'Aptt/Ptt',
    'category': 'Hematology',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'C-Reactive Protein (CRP), Quantitative',
    'category': 'Hepatitis / Serology',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'CKMM',
    'category': 'Chemistry',
    'price': '₱360',
    'notes': ''
  },
  {
    'name': 'Creatinine',
    'category': 'Chemistry',
    'price': '₱60',
    'notes': ''
  },
  {
    'name': 'Tsh (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱350',
    'notes': 'CLIA'
  },
  {
    'name': 'hs-CRP + CRP',
    'category': 'Hepatitis / Serology',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'D-Dimer Assay',
    'category': 'Chemistry',
    'price': '₱900',
    'notes': ''
  },
  {
    'name': 'T3 (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱300',
    'notes': 'CLIA'
  },
  {
    'name': 'Rheumatoid Factor (Rf)',
    'category': 'Hepatitis / Serology',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'FBS',
    'category': 'Chemistry',
    'price': '₱60',
    'notes': ''
  },
  {
    'name': 'T4 (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱300',
    'notes': 'CLIA'
  },
  {
    'name': 'Sle/Ana',
    'category': 'Hepatitis / Serology',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'GGTP',
    'category': 'Chemistry',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Ft3 (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱350',
    'notes': 'CLIA'
  },
  {
    'name': 'Human C3',
    'category': 'Hepatitis / Serology',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'HbA1c',
    'category': 'Chemistry',
    'price': '₱450',
    'notes': ''
  },
  {
    'name': 'Ft4 (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱350',
    'notes': 'CLIA'
  },
  {
    'name': 'Nt-Probnp',
    'category': 'Hepatitis / Serology',
    'price': '₱1,300',
    'notes': ''
  },
  {
    'name': 'Inorganic Phosphorous',
    'category': 'Chemistry',
    'price': '₱180',
    'notes': ''
  },
  {
    'name': 'Fsh (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'H. Pylori',
    'category': 'Hepatitis / Serology',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'LDH',
    'category': 'Chemistry',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Cortisol',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Lipase',
    'category': 'Chemistry',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Lh (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'Hbsag (Screening)',
    'category': 'Hepatitis / Serology',
    'price': '₱120',
    'notes': ''
  },
  {
    'name': 'Lipid Profile (Tc,Tg,Hdl,Ldv,Vldl)',
    'category': 'Chemistry',
    'price': '₱450',
    'notes': ''
  },
  {
    'name': 'Prolactin (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'Hbsa Titer (A)',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Magnesium',
    'category': 'Chemistry',
    'price': '₱180',
    'notes': ''
  },
  {
    'name': 'Estradiol (Clia) E2',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'Anti-Hbs Titer (B)',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'OGCT (FLAVORED) 50grms,75,100',
    'category': 'Chemistry',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Progesteron (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'ANTI-HBC IgM ( C )',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'OGTT  (FLAVORED) 50grms,75,100',
    'category': 'Chemistry',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Thyroglobulin (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱1,400',
    'notes': 'CLIA'
  },
  {
    'name': 'ANTI-HBC IgG (D)',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Potassium',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Testosterone (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'Anti-Hbe  ( E )',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'SGOT',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Beta-Hcg (Clia)',
    'category': 'Thyroid / Hormone',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'HBEAg (F)',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'SGPT',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Procalcitonin',
    'category': 'Thyroid / Hormone',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Anti-Hcv (G)',
    'category': 'Hepatitis / Serology',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Sodium',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Anti-Mullerian Hormone (AMH)',
    'category': 'Thyroid / Hormone',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Anti-HAV IgM (H)',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Tot. Calcium Or Ionized Calcium',
    'category': 'Chemistry',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'Anti-Ccp',
    'category': 'Thyroid / Hormone',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'ANTI-HAV IgG (I )',
    'category': 'Hepatitis / Serology',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Total Cholesterol',
    'category': 'Chemistry',
    'price': '₱60',
    'notes': ''
  },
  {
    'name': 'Hepatitis B Profile',
    'category': 'Hepatitis / Serology',
    'price': '₱1,000',
    'notes': ''
  },
  {
    'name': 'Total Ck',
    'category': 'Chemistry',
    'price': '₱360',
    'notes': ''
  },
  {
    'name': 'Complete Hepatitis Profile',
    'category': 'Hepatitis / Serology',
    'price': '₱1,500',
    'notes': ''
  },
  {
    'name': 'Total Protein',
    'category': 'Chemistry',
    'price': '₱65',
    'notes': ''
  },
  {
    'name': 'CEA',
    'category': 'Cancer Markers',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'TPAG',
    'category': 'Chemistry',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'AFP',
    'category': 'Cancer Markers',
    'price': '₱500',
    'notes': 'CLIA'
  },
  {
    'name': 'Urine C/S',
    'category': 'Microbiology',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Triglycerides',
    'category': 'Chemistry',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'PSA',
    'category': 'Cancer Markers',
    'price': '₱600',
    'notes': 'CLIA'
  },
  {
    'name': "Pap's Smear",
    'category': 'Microbiology',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'Uric Acid',
    'category': 'Chemistry',
    'price': '₱60',
    'notes': ''
  },
  {
    'name': 'Free Psa (Clia)',
    'category': 'Cancer Markers',
    'price': '₱800',
    'notes': 'CLIA'
  },
  {
    'name': 'Gram Stain',
    'category': 'Microbiology',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Vitamin D Assay',
    'category': 'Chemistry',
    'price': '₱700',
    'notes': ''
  },
  {
    'name': 'CA 125',
    'category': 'Cancer Markers',
    'price': '₱800',
    'notes': 'CLIA'
  },
  {
    'name': 'AFB',
    'category': 'Microbiology',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Ferritin',
    'category': 'Chemistry',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'CA 19-9',
    'category': 'Cancer Markers',
    'price': '₱800',
    'notes': 'CLIA'
  },
  {
    'name': 'KOH',
    'category': 'Microbiology',
    'price': '₱70',
    'notes': ''
  },
  {
    'name': 'Iron Test',
    'category': 'Chemistry',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'CA 15-3',
    'category': 'Cancer Markers',
    'price': '₱800',
    'notes': 'CLIA'
  },
  {
    'name': 'Total Iron Binding Capacity (Tibc) Test',
    'category': 'Chemistry',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Microalbumin',
    'category': 'Chemistry',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Methamphetamine Test',
    'category': 'Drug Test',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': 'Spirometry',
    'category': 'Special Laboratory',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'THC Test',
    'category': 'Drug Test',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': 'Routine Urinalysis',
    'category': 'Urinalysis',
    'price': '₱50',
    'notes': ''
  },
  {
    'name': '2D Echo with Color Doppler',
    'category': '2D Echo w/ Doppler',
    'price': '₱1,800',
    'notes': ''
  },
  {
    'name': 'BILE',
    'category': 'Urinalysis',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': '2D Echo with Doppler - 24-Hour Result',
    'category': '2D Echo w/ Doppler',
    'price': '₱2,700',
    'notes': ''
  },
  {
    'name': 'Ketone',
    'category': 'Urinalysis',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': 'Routine Fecalysis',
    'category': 'Fecalysis',
    'price': '₱50',
    'notes': ''
  },
  {
    'name': '24 Hrs Creatinine',
    'category': 'Urinalysis',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': '(Ifob) Occult Blood',
    'category': 'Fecalysis',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'ECG',
    'category': 'ECG',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Urine Sod, Pot,Chloride',
    'category': 'Urinalysis',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Semen Analysis',
    'category': 'Fecalysis',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'Chest X-ray',
    'category': 'X-ray',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Micro Alb/Micral',
    'category': 'Urinalysis',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Kato Kats',
    'category': 'Fecalysis',
    'price': '₱200',
    'notes': ''
  },
  {
    'name': 'Basic 5 with Drug Test',
    'category': 'Packages',
    'price': '₱550',
    'notes': ''
  },
  {
    'name': 'Pregnancy Test - Urine or Serum',
    'category': 'Urinalysis',
    'price': '₱150',
    'notes': ''
  },
  {
    'name': 'Stool Conc. Technique',
    'category': 'Fecalysis',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Basic 5',
    'category': 'Packages',
    'price': '₱450',
    'notes': ''
  },
  {
    'name': 'Random Albumin/Protein',
    'category': 'Urinalysis',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Amoeba Test',
    'category': 'Fecalysis',
    'price': '₱60',
    'notes': ''
  },
  {
    'name': 'Basic 5 with Drug Test and ECG',
    'category': 'Packages',
    'price': '₱650',
    'notes': ''
  },
  {
    'name': 'Random Urine Creatinine',
    'category': 'Urinalysis',
    'price': '₱300',
    'notes': ''
  },
  {
    'name': 'Chest X-ray (Ap)',
    'category': 'X-ray',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Neck Ultrasound',
    'category': 'Ultrasound',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Chest X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Neck Ultrasound With Ti-Rads',
    'category': 'Ultrasound',
    'price': '₱750',
    'notes': ''
  },
  {
    'name': 'Chest X-ray (Pa)',
    'category': 'X-ray',
    'price': '₱250',
    'notes': ''
  },
  {
    'name': 'Pancreas Ultrasound',
    'category': 'Ultrasound',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Chest X-ray (Pa) With Apicolordotic View',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Pelvic Ultrasound',
    'category': 'Ultrasound',
    'price': '₱100',
    'notes': ''
  },
  {
    'name': 'Chest X-ray (Pa/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Prostate Ultrasound',
    'category': 'Ultrasound',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Chest X-ray  (Pa/L) With Apicolodotic View',
    'category': 'X-ray',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Thyroid Ultrasound',
    'category': 'Ultrasound',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Chest X-ray With Abdominal Shield (Ap)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Thyroid With Ti-Rads',
    'category': 'Ultrasound',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Chest X-ray With Abdominal Shield (Ap/L)',
    'category': 'X-ray',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Bps',
    'category': 'Ultrasound',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Chest X-ray With Abdominal Shield (Pa)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Breast Ultrasound With Bi-Rads',
    'category': 'Ultrasound',
    'price': '₱700',
    'notes': ''
  },
  {
    'name': 'Chest X-ray With Abdominal Shield (Pa/L)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Gall Bladder Ultrasound',
    'category': 'Ultrasound',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Knee X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Hbt Ultrasound',
    'category': 'Ultrasound',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Knee X-ray (Ap/L/O)',
    'category': 'X-ray',
    'price': '₱1,200',
    'notes': ''
  },
  {
    'name': 'Kidneys Ultrasound',
    'category': 'Ultrasound',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Knee X-ray (Ap/O)',
    'category': 'X-ray',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Kub Ultrasound',
    'category': 'Ultrasound',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Left Knee X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Kub With Prostate Ultrasound',
    'category': 'Ultrasound',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Left Knee -Ray (Ap/L/O)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Liver Ultrasound',
    'category': 'Ultrasound',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Left Knee X-ray (Ap/O)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Lower Abdominal Ultrasound',
    'category': 'Ultrasound',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Right Knee X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Tvs Ultrasound',
    'category': 'Ultrasound',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Right Knee -Ray (Ap/L/O)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Upper Abdominal Ultrasound',
    'category': 'Ultrasound',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Right Knee X-ray (Ap/O)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Urinary Bladder Ultrasound',
    'category': 'Ultrasound',
    'price': '₱350',
    'notes': ''
  },
  {
    'name': 'Arm X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Whole Abdominal Ultrasound',
    'category': 'Ultrasound',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Forearm X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Whole Abdominal With Prostate Ultrasound',
    'category': 'Ultrasound',
    'price': '₱750',
    'notes': ''
  },
  {
    'name': 'Left Arm X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': '4D Ultrasound',
    'category': 'Ultrasound',
    'price': '₱1,500',
    'notes': ''
  },
  {
    'name': 'Left Forearm X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Right Arm X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Right Forearm X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Lumbosacral Spine X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Lumbosacral Spine X-ray (Ap/L/O)',
    'category': 'X-ray',
    'price': '₱1,000',
    'notes': ''
  },
  {
    'name': 'Lumbo Sacral Spine X-ray (Oblique)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Thoracic Cage/Rib Cage (Ap)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Nasal Bone X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱500',
    'notes': ''
  },
  {
    'name': 'Foot X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱800',
    'notes': ''
  },
  {
    'name': 'Foot X-ray (Ap/L/O)',
    'category': 'X-ray',
    'price': '₱1,200',
    'notes': ''
  },
  {
    'name': 'Foot X-ray (Ap/O)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Left Foot X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Left Foot X-ray (Ap/Lo)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Left Foot X-ray (Ap/O)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Right Foot X-ray (Ap/L)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Right Foot X-ray (Ap/Lo)',
    'category': 'X-ray',
    'price': '₱600',
    'notes': ''
  },
  {
    'name': 'Right Left Foot X-ray (Ap/O)',
    'category': 'X-ray',
    'price': '₱400',
    'notes': ''
  },
  {
    'name': 'Flu Vaccine',
    'category': 'Vaccination',
    'price': '₱1,200',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'MMR Vaccine',
    'category': 'Vaccination',
    'price': '₱600',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Hepatitis A Vaccine',
    'category': 'Vaccination',
    'price': '₱1,800',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Hepatitis B Vaccine',
    'category': 'Vaccination',
    'price': '₱1,000',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'TDAP Vaccine',
    'category': 'Vaccination',
    'price': '₱1,800',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Engerix-B Hepatitis B Vaccine',
    'category': 'Vaccination',
    'price': '₱1,200',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Varicella Vaccine',
    'category': 'Vaccination',
    'price': '₱2,500',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Anti-Tetanus Toxoid',
    'category': 'Vaccination',
    'price': '₱400',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Pneumonia Vaccine',
    'category': 'Vaccination',
    'price': '₱3,500',
    'notes': 'Confirm stock before visit'
  },
  {
    'name': 'Home Service',
    'category': 'Home Service',
    'price': 'Contact branch',
    'notes': 'Subject to location and schedule'
  },
  {
    'name': 'Mobile APE and Onsite Drug Testing',
    'category': 'Mobile Onsite',
    'price': 'Request quote',
    'notes': 'For companies and groups'
  }
]

export const hmoPartners = [
  { name: 'Maxicare', image: require('@/assets/landingpage/logos/maxicare.png') },
  { name: 'Philippine British', image: require('@/assets/landingpage/logos/phil-british.png') },
  { name: 'MedAsia', image: require('@/assets/landingpage/logos/medasia.png') },
  { name: 'MediPlus', image: require('@/assets/landingpage/logos/mediplus.png') },
  { name: 'MediLink', image: require('@/assets/landingpage/logos/medilink.png') },
  { name: 'PhilCare', image: require('@/assets/landingpage/logos/philcare.png') },
  { name: 'Valucare', image: require('@/assets/landingpage/logos/valucare.png') },
  { name: 'Insular Life', image: require('@/assets/landingpage/logos/insular.webp') },
  { name: 'Sun Life Grepa', image: require('@/assets/landingpage/logos/sunlife.png') },
  { name: 'Intellicare x Avega', image: require('@/assets/landingpage/logos/intellicarexavega.webp') },
  { name: 'Cocolife', image: require('@/assets/landingpage/logos/cocolife.png') },
  { name: 'Etiqa', image: require('@/assets/landingpage/logos/etiqa.png') },
  { name: 'iCare', image: require('@/assets/landingpage/logos/icare.png') },
  { name: 'Pacific Cross', image: require('@/assets/landingpage/logos/pacific-cross.png') },
  { name: 'Medocare', image: require('@/assets/landingpage/logos/medocare.png') }
]

export const accreditations = [
  { name: 'DOH', image: require('@/assets/landingpage/logos/doh.png') },
  { name: 'Quezon City', image: require('@/assets/landingpage/logos/qc.png') },
  { name: 'PNP', image: require('@/assets/landingpage/logos/pnp.png') },
  { name: 'URS', image: require('@/assets/landingpage/logos/urs.png') },
  { name: 'IAF', image: require('@/assets/landingpage/logos/iaf.png') }
]

export const whyChooseUs = [
  {
    title: 'Accurate and affordable care',
    text: 'Diagnostic healthcare services designed around reliable results, practical prices, and everyday patient needs.',
    icon: 'pi pi-heart'
  },
  {
    title: 'Modern automated facilities',
    text: 'Fully automated laboratory facilities support fast, consistent service for patients, companies, and partner clinics.',
    icon: 'pi pi-cog'
  },
  {
    title: 'Certified quality assurance',
    text: 'ISO 9001:2015 certification and EQAS participation help support confidence in reported patient results.',
    icon: 'pi pi-verified'
  },
  {
    title: 'Licensed medical team',
    text: 'Services are supported by licensed and well-trained medical doctors, technologists, radiology staff, nurses, and technicians.',
    icon: 'pi pi-users'
  }
]

export const missionVisionQuality = [
  {
    title: 'Mission',
    text: 'Aims to provide precise, top-quality healthcare services at affordable prices.',
    icon: 'pi pi-bullseye'
  },
  {
    title: 'Vision',
    text: 'Aims to provide quality diagnostic healthcare solutions to clients at reliable and high top quality healthcare services.',
    icon: 'pi pi-eye'
  },
  {
    title: 'Quality Policy',
    text: 'THE MAYON CLINICAL LABORATORY AND MEDICAL SERVICES aims to become an excellent top quality healthcare provider to all our clients and customers by delivering accurate, reliable and affordable diagnostic healthcare and services. Moreover the clinic ensures compliant to statutory requirements and international standards.',
    icon: 'pi pi-shield'
  }
]

export const coreValues = [
  {
    title: 'Courage',
    text: 'To Display courage to challenge the status quo.'
  },
  {
    title: 'Innovation',
    text: 'To Embrace Innovation. To create better solutions for our customers and patients.'
  },
  {
    title: 'Excellence',
    text: 'To Drive Excellence. We work toward accurate, reliable, and high-quality diagnostic service.'
  },
  {
    title: 'Trust',
    text: 'To Cultivate trust by consistently doing the right thing.'
  },
  {
    title: 'Care',
    text: 'To Care for our customers by sharing our hearts and minds to deliver positive outcomes.'
  },
  {
    title: 'Solutions',
    text: 'To Find solutions instead of making excuses.'
  }
]

export const faqs = [
  {
    question: 'Do I need an appointment?',
    answer: 'Walk-ins may be accepted for many services, but package, imaging, vaccine, HMO, and onsite requests should be confirmed with the branch first.'
  },
  {
    question: 'Are the prices final?',
    answer: 'Prices shown on the website are for reference only and may change without prior notice. Please contact the branch to confirm final price and availability.'
  },
  {
    question: 'Do you accept HMO?',
    answer: 'Mayon works with selected HMO partners. Coverage depends on the service, patient account, and approval process.'
  },
  {
    question: 'How can I get directions?',
    answer: 'Use the Get directions button in the branch details. It opens Google Maps directions without requiring a Google Maps API key.'
  }
]

export const galleryImages = [
  {
    filename: 'gallery-clinic-reception.jpg',
    title: 'Clinic entrance and reception',
    category: 'Clinic',
    caption: 'The reception area welcomes visitors for branch check-in and service inquiries.',
    alt: 'Mayon clinic entrance with reception counter and patient waiting area',
    width: 1600,
    height: 912,
    relatedPath: '/branches',
    linkLabel: 'View branch details'
  },
  {
    filename: 'gallery-patient-support-area.jpg',
    title: 'Patient support area',
    category: 'Patient support',
    caption: 'A patient support desk provides space for service questions and visit coordination.',
    alt: 'Patient support desk with chairs in a Mayon clinic service area',
    width: 1600,
    height: 1069
  },
  {
    filename: 'gallery-xray-equipment.jpg',
    title: 'X-ray equipment detail',
    category: 'Imaging',
    caption: 'Imaging equipment is part of the clinic environment for requested diagnostic services.',
    alt: 'Close view of X-ray equipment controls in the imaging area',
    width: 1600,
    height: 1069
  },
  {
    filename: 'gallery-imaging-workflow.jpg',
    title: 'Diagnostic imaging area',
    category: 'Imaging',
    caption: 'The imaging area supports patients with diagnostic service requests confirmed through the branch.',
    alt: 'Diagnostic imaging room with equipment and clinic work area',
    width: 1600,
    height: 1069,
    relatedPath: '/services',
    linkLabel: 'Learn more about diagnostic services'
  },
  {
    filename: 'gallery-specimen-preparation.jpg',
    title: 'Specimen preparation',
    category: 'Laboratory',
    caption: 'Organized laboratory work areas support preparation steps for requested diagnostic tests.',
    alt: 'Laboratory specimen preparation area with organized work surfaces',
    width: 1600,
    height: 1069
  },
  {
    filename: 'gallery-microscopy-workstation.jpg',
    title: 'Microscopy workstation',
    category: 'Laboratory',
    caption: 'Microscopy workstations are part of the laboratory environment supporting patient diagnostics.',
    alt: 'Microscope workstation on a laboratory counter',
    width: 1600,
    height: 1069
  },
  {
    filename: 'gallery-laboratory-processing.jpg',
    title: 'Laboratory processing area',
    category: 'Laboratory',
    caption: 'Laboratory counters and equipment support processing steps for requested diagnostic services.',
    alt: 'Diagnostic laboratory processing area with equipment and counters',
    width: 1600,
    height: 1069
  },
  {
    filename: 'gallery-clinic-staff.jpg',
    title: 'Clinic staff support',
    category: 'Team',
    caption: 'Clinic staff help connect patient inquiries, testing needs, packages, and follow-up steps.',
    alt: 'Mayon clinic staff in a patient service area',
    width: 1002,
    height: 1500
  },
  {
    filename: 'gallery-laboratory-overview.jpg',
    title: 'Laboratory overview',
    category: 'Facilities',
    caption: 'A broader view of the laboratory shows organized facilities behind diagnostic services.',
    alt: 'Laboratory overview with diagnostic equipment and organized counters',
    width: 1600,
    height: 1069,
    relatedPath: '/services',
    linkLabel: 'Browse laboratory services'
  }
]
